/* eslint-disable */
import React from 'react';

const NotFoundPage = () => {
	return (
		<div>404 Page not found!</div>
	);
};
export default NotFoundPage;